import Phaser from 'phaser';
import type { PlayerAction } from '../types';

interface PlayerKeys {
  left: Phaser.Input.Keyboard.Key;
  right: Phaser.Input.Keyboard.Key;
  jump: Phaser.Input.Keyboard.Key;
  drop: Phaser.Input.Keyboard.Key;
  bubble: Phaser.Input.Keyboard.Key;
}

export class InputRouter {
  private readonly players: [PlayerKeys, PlayerKeys];
  readonly pause: Phaser.Input.Keyboard.Key;
  readonly mute: Phaser.Input.Keyboard.Key;

  constructor(scene: Phaser.Scene) {
    const keyboard = scene.input.keyboard;
    if (!keyboard) throw new Error('Ta gra wymaga klawiatury.');

    const key = (code: number) => keyboard.addKey(code);
    this.players = [
      {
        left: key(Phaser.Input.Keyboard.KeyCodes.LEFT),
        right: key(Phaser.Input.Keyboard.KeyCodes.RIGHT),
        jump: key(Phaser.Input.Keyboard.KeyCodes.UP),
        drop: key(Phaser.Input.Keyboard.KeyCodes.DOWN),
        bubble: key(Phaser.Input.Keyboard.KeyCodes.ENTER),
      },
      {
        left: key(Phaser.Input.Keyboard.KeyCodes.A),
        right: key(Phaser.Input.Keyboard.KeyCodes.D),
        jump: key(Phaser.Input.Keyboard.KeyCodes.W),
        drop: key(Phaser.Input.Keyboard.KeyCodes.S),
        bubble: key(Phaser.Input.Keyboard.KeyCodes.SPACE),
      },
    ];
    this.pause = key(Phaser.Input.Keyboard.KeyCodes.ESC);
    this.mute = key(Phaser.Input.Keyboard.KeyCodes.M);

    keyboard.addCapture([
      Phaser.Input.Keyboard.KeyCodes.W,
      Phaser.Input.Keyboard.KeyCodes.A,
      Phaser.Input.Keyboard.KeyCodes.S,
      Phaser.Input.Keyboard.KeyCodes.D,
      Phaser.Input.Keyboard.KeyCodes.SPACE,
      Phaser.Input.Keyboard.KeyCodes.UP,
      Phaser.Input.Keyboard.KeyCodes.DOWN,
      Phaser.Input.Keyboard.KeyCodes.LEFT,
      Phaser.Input.Keyboard.KeyCodes.RIGHT,
      Phaser.Input.Keyboard.KeyCodes.ENTER,
    ]);
  }

  down(slot: 0 | 1, action: PlayerAction): boolean {
    const binding = this.players[slot][action];
    return binding.isDown;
  }

  justDown(slot: 0 | 1, action: 'jump' | 'drop' | 'bubble'): boolean {
    const binding = this.players[slot][action];
    return Phaser.Input.Keyboard.JustDown(binding);
  }

  clear(): void {
    for (const bindings of this.players) {
      for (const binding of Object.values(bindings)) binding?.reset();
    }
  }
}
